import { useAuth } from "@/lib/auth";
import Header from "./Header";
import Footer from "./Footer";
import LoginModal from "./LoginModal";

export default function WebFrame({ children, hideChrome = false }) {
    const { modalOpen } = useAuth();
    return (
        <div className="flex min-h-screen flex-col bg-veda-surface">
            {!hideChrome && <Header />}
            <main className="flex-1">{children}</main>
            {!hideChrome && <Footer />}
            {modalOpen && <LoginModal />}
        </div>
    );
}
